module.exports = __webpack_public_path__ + "media/images/favicons/android-chrome-192x192-15959111f4439786603dd25935bd3132.png";